import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import * as loaderNames from '../../../consts/loader/loaderNames';
import useDidUpdate from '../../../hooks/useDidUpdate';
import ErrorHandlerService from '../../../services/errorHandlerService';
import PairingHandlerService from '../../../services/pairingHandlerService';
import {makeSelectIsScpCheckInProgress} from '../../../state/selectors/global';
import {makeSelectIsDeviceSyncInProgress} from '../../../state/selectors/yapEncrypted';

const mapStateToProps = createStructuredSelector({
    isDeviceSyncInProgress: makeSelectIsDeviceSyncInProgress(),
    isHolderSyncInProgress: makeSelectIsDeviceSyncInProgress(true),
    isScpCheckInProgress: makeSelectIsScpCheckInProgress(),
});

const YapPairingChecker = ({isDeviceSyncInProgress, isHolderSyncInProgress, isScpCheckInProgress}) => {
    const onChange = (isInProgress, isHolder = false) => {
        if (isInProgress) {
            new PairingHandlerService().pairingIsStarted();
        } else {
            new ErrorHandlerService().checkYapError(isHolder);

            if (isDeviceSyncInProgress || isHolderSyncInProgress) return;

            new PairingHandlerService().pairingIsStopped();
        }
    };

    useDidUpdate(() => {
        if (isScpCheckInProgress) {
            new PairingHandlerService().pairingIsStarted(loaderNames.SCP_CHECK_LOADER);
        } else {
            new PairingHandlerService().pairingIsStopped(loaderNames.SCP_CHECK_LOADER);
        }
    }, [isScpCheckInProgress]);

    useDidUpdate(() => {
        onChange(isDeviceSyncInProgress);
    }, [isDeviceSyncInProgress]);

    useDidUpdate(() => {
        onChange(isHolderSyncInProgress, true);
    }, [isHolderSyncInProgress]);

    return null;
};

export default connect(mapStateToProps)(YapPairingChecker);
